import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "Справочник содержит различные типы пакетов по объему.", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Нормативная ширина, нормативная высота (мм) - Подставляются в ширину и высоту пакета при добавлении/импорте. "),
  /*#__PURE__*/_createElementVNode("li", null, " Альтернативные наименования - список наименований данного типа пакета через \",\". Используется при импорте. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoDialog = _resolveComponent("InfoDialog")!

  return (_openBlock(), _createBlock(_component_InfoDialog, {
    title: "Справка: Типы пакетов по объему",
    ref: "dialog"
  }, {
    infoForm: _withCtx(({}) => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }, 512))
}